import { useQuery } from "react-query"
import Select from "react-select"
import axios from "axios"
import cn from "classnames"
import customStyles from "./styles"
import { Driver } from "interfaces/driver"
import DropdownIndicatorForSelect from "../DropdownIndicatorForSelect"
import ConditionalView from "../ConditionalView"

const fetchDrivers = async () => {
  const { data } = await axios.get<{ results: Driver[] }>("drivers/")

  const output = data.results.map((driver: Driver) => ({
    value: driver.id,
    label: driver?.full_name,
  }))

  return output
}

const MONITOR_TYPES = [
  {
    value: "Veeder-Root TLS-350",
    label: "Veeder-Root TLS-350",
  },
  {
    value: "Veeder-Root TLS-450Plus",
    label: "Veeder-Root TLS-450Plus",
  },
  {
    value: "INCON TS-2001",
    label: "INCON TS-2001",
  },
  {
    value: "PDS Integration",
    label: "PDS Integration",
  },
  {
    value: "EcoGreen Integration",
    label: "EcoGreen Integration",
  },
  {
    value: "Telapoint Integration",
    label: "Telapoint Integration",
  },
  {
    value: "Anova Integration",
    label: "Anova Integration",
  },
  {
    value: "MyTankInfo",
    label: "MyTankInfo",
  },
  {
    value: "SmartTank",
    label: "SmartTank",
  },
  {
    value: "Titan",
    label: "Titan",
  },
  {
    value: "Neevo Integration",
    label: "Neevo Integration",
  },
  {
    value: "Insite360 Integration",
    label: "Insite360 Integration",
  },
  {
    value: "Gravitate Inventory Management",
    label: "Gravitate Inventory Management",
  },
  {
    value: "Kiva Integration",
    label: "Kiva Integration",
  },
  {
    value: "TrackGas Integration",
    label: "TrackGas Integration",
  },
  {
    value: "TLS450 Web Integration",
    label: "TLS450 Web Integration",
  },
  {
    value: "Invigicom Integration",
    label: "Invigicom Integration",
  },
  {
    value: "Invigicom API Integration",
    label: "Invigicom API Integration",
  },
] as any

const MonitorTypePicker = (props: {
  selected?: number
  className?: string
  label?: string
  onSelect?: (item: any) => void
  error?: string
}) => (
  <div className={cn("flex-c-box relative", props.className)}>
    {!props.label ? null : (
      <>
        <span style={{ color: "#486f88", fontWeight: "bold" }}>
          {props.label}
        </span>
        <div style={{ marginTop: 8 }} />
      </>
    )}

    <Select
      styles={customStyles({
        border: props.error ? "1px solid #fa5c7c" : "",
      })}
      placeholder="Choose Monitor Type"
      options={MONITOR_TYPES}
      onChange={props.onSelect}
      components={
        props.error ? { DropdownIndicator: DropdownIndicatorForSelect } : {}
      }
      value={
        MONITOR_TYPES?.find((item: any) => item.value === props.selected) ?? []
      }
    />
    <ConditionalView condition={!!props.error}>
      <span className=" absolute left-0 -bottom-[16px] text-[12px] text-[#fa5c7c]">
        {props.error}
      </span>
    </ConditionalView>
  </div>
)

export default MonitorTypePicker
